import { render, staticRenderFns } from "./FacilityEditPropertyType.vue?vue&type=template&id=57184f01&"
import script from "./FacilityEditPropertyType.vue?vue&type=script&lang=js&"
export * from "./FacilityEditPropertyType.vue?vue&type=script&lang=js&"
import style0 from "./FacilityEditPropertyType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports